/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactElement } from 'react'
import DefaultEditor from './DefaultEditor'
import widgetsService from 'live/services/widgets'

// Record<string, any> are used to type unknown objects

export function editorBuilder(
    type: string,
    tabs: ReactElement[]
): (
    widgetConfigStore: Record<string, any>,
    widgetConfigActions: Record<string, any>,
    widgetDataStore: Record<string, any>,
    widgetDataActions: Record<string, any>,
    meta: Array<any>
) => React.ReactNode {
    // check if user add this option to `.config()`
    const currentConfig = widgetsService.config(type)
    tabs.forEach(tab => {
        if (Array.isArray(tab?.props.children)) {
            tab.props.children.forEach((config: ReactElement) => {
                if (Object.prototype.hasOwnProperty.call(config?.props, 'configField')) {
                    if (
                        !Object.prototype.hasOwnProperty.call(currentConfig, config.props.configField) &&
                        !config.props.editorOnly
                    ) {
                        console.error(`${config.props.configField} not defined on conf for type ${type}!`)
                    }
                }
            })
        }
    })

    return function editorHOC<T>(
        widgetConfigStore: Record<string, any>,
        widgetConfigActions: Record<string, any>,
        widgetDataStore: Record<string, any>,
        widgetDataActions: Record<string, any>,
        meta: Array<any>
    ): (props: T) => React.ReactNode {
        return function editorBuilder(props: T): React.ReactNode {
            return (
                <DefaultEditor
                    widgetConfigStore={widgetConfigStore}
                    widgetDataActions={widgetDataActions}
                    widgetConfigActions={widgetConfigActions}
                    widgetDataStore={widgetDataStore}
                    meta={meta}
                    tabs={tabs}
                    {...props}
                />
            )
        }
    }
}
